export const UPDATE_USER_PROFILE = "UPDATE_USER_PROFILE";
export const UPDATE_USER_BUDDIES = "UPDATE_USER_BUDDIES";
export const ADD_BUDDY = "ADD_BUDDY";
export const DELETE_BUDDY = "DELETE_BUDDY";
